"use client"

import { motion, useScroll, useSpring } from "motion/react"
import { useEffect, useState } from "react"

export function ReadingProgress() {
    const [isVisible, setIsVisible] = useState(false)
    const { scrollYProgress } = useScroll()

    const scaleX = useSpring(scrollYProgress, {
        stiffness: 100,
        damping: 30,
        restDelta: 0.001
    })

    useEffect(() => {
        const handleScroll = () => {
            // Show progress bar only after scrolling down a bit
            if (window.scrollY > 100) {
                setIsVisible(true)
            } else {
                setIsVisible(false)
            }
        }

        window.addEventListener("scroll", handleScroll)
        return () => window.removeEventListener("scroll", handleScroll)
    }, [])

    return (
        <motion.div
            className="fixed top-0 left-0 right-0 h-1 bg-linear-to-r from-premium-violet via-premium-cyan to-white origin-left z-50 transform-gpu"
            style={{ scaleX, opacity: isVisible ? 1 : 0 }}
            transition={{ opacity: { duration: 0.2 } }}
        />
    )
}
